import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { composeWithDevTools } from "@redux-devtools/extension";
import { urls } from "@selector/shared";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";

import { webSocketClient } from "@/tools.ts";

import WebApiClient from "../../api/WebApiClient.ts";
import rootReducer from "../reducer.ts";

function configureStore(apolloClient: ApolloClient<NormalizedCacheObject>, initialState = {}) {
  // Configure Redux devtools extension but hide APOLLO and NOTIFICATION actions
  const composeEnhancers = composeWithDevTools({
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
    trace: true,
    traceLimit: 25,
    actionsBlacklist: ["RNS_"], // we do not want to see the "ALERT" related actions (e.g. show/hide)
  });

  const enhancer = composeEnhancers(
    _getMiddleware(apolloClient),
    // other store enhancers if any
  );

  const store = createStore(rootReducer(), initialState, enhancer);
  webSocketClient.setStore(store); // To Keep the store updated with (re)connection of web socket
  //  _enableHotLoader(store); // remove completely when react-hot-loader works properly
  return store;
}

function _getMiddleware(apolloClient: ApolloClient<NormalizedCacheObject>) {
  const webApiClient = new WebApiClient(urls, apolloClient);
  const middleware = [thunk.withExtraArgument(webApiClient)];

  if (import.meta.env.DEV) {
    // middleware = [...middleware, logger];
    // SEE Redux debugger
  }

  return applyMiddleware(...middleware);
}

export default configureStore;
